import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { isEqual, defaults } from "lodash";
import { log } from "../../utils/logger";

// State
import { updateUser, deleteUser } from "../../redux/actions/userActions";

// UI Components
import { toastr } from "react-redux-toastr";
import { Col, Container, Row } from "reactstrap";

import AccountNavigation from "./AccountNavigation";
import Profile from "./Profile";
import Security from "./Security";
// import Notifications from "./Notifications";
// import DeleteAccount from "./DeleteAccount";

class Account extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: defaults(props.user, {
        current_password: "",
        new_password: "",
        confirm_password: "",
      }),
      selected_view: props.match.params.view || "profile",
    };

    this.onChangeUser = this.onChangeUser.bind(this);
    this.onSubmitUser = this.onSubmitUser.bind(this);
    this.onDeleteUser = this.onDeleteUser.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const state = {};
    if (!isEqual(nextProps.match.params.view, prevState.selected_view)) {
      state.selected_view = nextProps.match.params.view;
    }
    if (!isEqual(nextProps.user, prevState.user)) {
      state.user = defaults(nextProps.user, {
        current_password: "",
        new_password: "",
        confirm_password: "",
      });
    }
    return state;
  }

  onChangeUser({ target }) {
    const { user } = this.state;

    user[target.name] = target.value;

    this.setState({ user });
  }

  onSubmitUser() {
    const { user } = this.state;

    this.props.updateUser(user);
  }

  onDeleteUser() {
    const { user } = this.state;

    log("Deleting user", user);
    toastr.error("We do not yet support deleting a user - please try again later");
    // this.props.deleteUser(user);
  }

  render() {
    const { user, selected_view } = this.state;

    return (
      <Container fluid className="p-0">
        <h1 className="h3 mb-3">Settings</h1>

        <Row>
          <Col md="3" xl="2">
            <AccountNavigation selected={selected_view} />
          </Col>

          <Col md="9" xl="10">
            <Profile
              selected={selected_view}
              user={user}
              onChange={this.onChangeUser}
              onSubmit={this.onSubmitUser}
            />

            <Security
              selected={selected_view}
              user={user}
              onChange={this.onChangeUser}
              onSubmit={this.onSubmitUser}
            />

            {/* REMOVED - as still in TBD */}
            {/*<Notifications selected={selected_view} />*/}

            {/* REMOVED - un-needed */}
            {/*<DeleteAccount selected={selected_view} onDelete={this.onDeleteUser} />*/}
          </Col>
        </Row>
      </Container>
    );
  }
}

Account.propTypes = {
  user: PropTypes.object.isRequired,
  deleteUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps, { updateUser, deleteUser })(withRouter(Account));
